var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        size: "lg",
        title: `Manage access to ${
          _setup.entityTypeNames[_setup.props.entityType].plural
        }`,
      },
      on: { closed: _setup.forceCloseHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between w-100" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.cancelHandler },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: { text: "Confirm", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _setup.execLoadedFn(_setup.confirmHandler)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "d-flex w-100 mx-3 py-3 bg-light rounded" }, [
          _c("div", { staticClass: "col-3" }, [
            _c("small", { staticClass: "text-muted" }, [_vm._v("Name")]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_setup.props.member?.user.Name)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("small", { staticClass: "text-muted" }, [_vm._v("E-mail")]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_setup.props.member?.user.Email)),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _setup.mode == "list" &&
      _setup.props.entityType == _setup.EntityType.TEMPLATE
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("label", {
                    staticClass: "mr-3 mb-0 text-capitalize",
                    domProps: {
                      textContent: _vm._s(
                        _setup.entityTypeNames[_setup.props.entityType].plural +
                          " restriction access:"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    _setup.BDropdown,
                    {
                      attrs: {
                        text: _setup.getAccessModeText(
                          _setup.accessRestriction
                        ),
                        variant: "outline-primary",
                      },
                    },
                    [
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _setup.updateAccessRestriction(
                                _setup.AccessRestriction.LISTED,
                                _setup.props.entityType
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _setup.getAccessModeText(
                                  _setup.AccessRestriction.LISTED
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _setup.updateAccessRestriction(
                                _setup.AccessRestriction.FULL_ACCESS,
                                _setup.props.entityType
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _setup.getAccessModeText(
                                  _setup.AccessRestriction.FULL_ACCESS
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          on: {
                            click: function ($event) {
                              return _setup.updateAccessRestriction(
                                _setup.AccessRestriction
                                  .ALL_READ_ONLY_PLUS_LISTED,
                                _setup.props.entityType
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _setup.getAccessModeText(
                                  _setup.AccessRestriction
                                    .ALL_READ_ONLY_PLUS_LISTED
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.showStoresDropdown
        ? _c(
            "div",
            { staticClass: "store-selector-wrapper mb-3" },
            [
              _c(
                _setup.BDropdown,
                {
                  ref: "storesDropdown",
                  attrs: {
                    split: "",
                    variant: "primary",
                    text: _setup.selectedStore?.Url,
                  },
                },
                _vm._l(_setup.availableStores, function (store) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: `store-${store.Id}`,
                      attrs: {
                        value: store.Url,
                        active: _vm.$store.state.store == store.Url,
                      },
                      on: {
                        click: function ($event) {
                          return _setup.onStoresDropdownClick(store)
                        },
                      },
                    },
                    [_c("div", [_vm._v(_vm._s(store.Url))])]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "entityContentContainer" }, [
        _c(
          "div",
          {
            staticClass: "entityContent",
            class: {
              disabled:
                _setup.accessRestriction ===
                _setup.AccessRestriction.FULL_ACCESS,
            },
          },
          [
            _setup.mode == "add"
              ? _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c("h6", {
                    staticClass: "font-weight-bold align-content-center mb-0",
                    domProps: {
                      textContent: _vm._s(
                        "Select the " +
                          _setup.entityTypeNames[_setup.props.entityType]
                            .singular +
                          " you want to give access to"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c("b-form-input", {
                        staticClass: "ml-3 w-50 h-100 search-input-gray",
                        attrs: {
                          type: "text",
                          debounce: "400",
                          placeholder: "Search",
                        },
                        model: {
                          value: _setup.searchString,
                          callback: function ($$v) {
                            _setup.searchString = $$v
                          },
                          expression: "searchString",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.mode == "list"
              ? _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c("h6", {
                    staticClass: "font-weight-bold",
                    domProps: {
                      textContent: _vm._s(
                        "Allowed " +
                          _setup.entityTypeNames[_setup.props.entityType].plural
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c("button", {
                        staticClass: "btn btn-outline-primary",
                        domProps: {
                          textContent: _vm._s(
                            "Add  " +
                              _setup.entityTypeNames[_setup.props.entityType]
                                .singular
                          ),
                        },
                        on: {
                          click: function ($event) {
                            return _setup.changeToAddMode()
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "ml-3 w-50 h-100 search-input-gray",
                        staticStyle: { width: "unset" },
                        attrs: {
                          type: "text",
                          debounce: "400",
                          placeholder: "Search",
                        },
                        model: {
                          value: _setup.searchString,
                          callback: function ($$v) {
                            _setup.searchString = $$v
                          },
                          expression: "searchString",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            (_setup.mode == "add" ? false : !_setup.entitiesAdded.length)
              ? _c("div", { staticClass: "text-center text-muted py-4" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "30",
                        height: "30",
                        viewBox: "0 0 30 30",
                        fill: "none",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_182_7372)" } },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M15 2.8125C18.2323 2.8125 21.3323 4.09654 23.6179 6.38214C25.9035 8.66774 27.1875 11.7677 27.1875 15C27.1875 18.2323 25.9035 21.3323 23.6179 23.6179C21.3323 25.9035 18.2323 27.1875 15 27.1875C11.7677 27.1875 8.66774 25.9035 6.38214 23.6179C4.09654 21.3323 2.8125 18.2323 2.8125 15C2.8125 11.7677 4.09654 8.66774 6.38214 6.38214C8.66774 4.09654 11.7677 2.8125 15 2.8125ZM15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875C11.877 19.6875 11.25 20.3145 11.25 21.0938C11.25 21.873 11.877 22.5 12.6562 22.5H17.3438C18.123 22.5 18.75 21.873 18.75 21.0938C18.75 20.3145 18.123 19.6875 17.3438 19.6875H16.875V14.5312C16.875 13.752 16.248 13.125 15.4688 13.125H12.6562C11.877 13.125 11.25 13.752 11.25 14.5312C11.25 15.3105 11.877 15.9375 12.6562 15.9375H14.0625V19.6875H12.6562ZM15 11.25C15.4973 11.25 15.9742 11.0525 16.3258 10.7008C16.6775 10.3492 16.875 9.87228 16.875 9.375C16.875 8.87772 16.6775 8.40081 16.3258 8.04918C15.9742 7.69754 15.4973 7.5 15 7.5C14.5027 7.5 14.0258 7.69754 13.6742 8.04918C13.3225 8.40081 13.125 8.87772 13.125 9.375C13.125 9.87228 13.3225 10.3492 13.6742 10.7008C14.0258 11.0525 14.5027 11.25 15 11.25Z",
                              fill: "#0D0324",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_182_7372" } }, [
                          _c("rect", {
                            attrs: { width: "30", height: "30", fill: "white" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      textContent: _vm._s(
                        "There are no " +
                          _setup.entityTypeNames[_setup.props.entityType]
                            .plural +
                          " allowed yet"
                      ),
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.mode == "list" &&
            _setup.entitiesAdded &&
            _setup.entitiesAdded.length > 0
              ? _c("b-table", {
                  staticClass: "w-100 table",
                  attrs: {
                    striped: "",
                    hover: "",
                    "thead-class": "table-header",
                    items: _setup.entitiesAdded,
                    fields: _setup.getTableFields(),
                    responsive: "sm",
                    busy: _setup.loading,
                    "empty-text":
                      "No " +
                      _setup.entityTypeNames[_setup.props.entityType].plural,
                    "empty-filtered-text":
                      "No " +
                      _setup.entityTypeNames[_setup.props.entityType].plural +
                      " matching your search",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "table-busy",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "align-items-center d-flex justify-content-center my-2 text-center my-2",
                              },
                              [
                                _c("b-spinner", {
                                  attrs: { variant: "primary" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  { staticClass: "ml-3 primary-text" },
                                  [_vm._v("Loading...")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "cell(image)",
                        fn: function (data) {
                          return [
                            data.item.thumbnail
                              ? _c(_setup.CPreview, {
                                  staticClass: "img",
                                  attrs: {
                                    src: data.item.thumbnail,
                                    thumbnail: "",
                                    "hide-wrapper": "",
                                  },
                                })
                              : _c("font-awesome-icon", {
                                  attrs: {
                                    icon: ["fas", "image"],
                                    size: "10x",
                                  },
                                }),
                          ]
                        },
                      },
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-baseline",
                              },
                              [
                                _c("span", [_vm._v(_vm._s(data.item.name))]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-with-overflow link",
                                    staticStyle: {
                                      color: "var(--Primary-primary, #7258e0)",
                                    },
                                  },
                                  [_vm._v(_vm._s(data.item.id))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-end" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      variant: "outline-primary",
                                      disabled: _setup.loading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _setup.removeEntityAccess(
                                          data.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Remove\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    114616611
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _setup.mode == "add"
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center check-head-container",
                      },
                      [
                        _c(_setup.CCheckbox, {
                          attrs: {
                            "aria-labelledby": "checkbox-label",
                            value: _setup.generalCheck,
                          },
                          on: {
                            input: function ($event) {
                              return _setup.checkAllPage($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { attrs: { id: "checkbox-label" } }, [
                          _vm._v(
                            _vm._s(
                              _setup.capitalizeFirstLetter(
                                _setup.entityTypeNames[_vm.entityType].singular
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _setup.isSomethingChecked
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "mr-1 ml-3",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                  disabled: _setup.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.changeCheckedEntityAccess(
                                      "add"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Select\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.isSomethingChecked
                          ? _c(
                              "b-btn",
                              {
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                  disabled: _setup.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.changeCheckedEntityAccess(
                                      "remove"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Remove\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-table", {
                      staticClass: "w-100 table",
                      attrs: {
                        striped: "",
                        hover: "",
                        "thead-class": "table-header",
                        items: _setup.entitiesToDisplay,
                        fields: _setup.getTableFields(),
                        responsive: "sm",
                        busy: _setup.loading,
                        "empty-text":
                          "No " +
                          _setup.entityTypeNames[_setup.props.entityType]
                            .plural,
                        "empty-filtered-text":
                          "No " +
                          _setup.entityTypeNames[_setup.props.entityType]
                            .plural +
                          " matching your search",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "align-items-center d-flex justify-content-center my-2 text-center my-2",
                                  },
                                  [
                                    _c("b-spinner", {
                                      attrs: { variant: "primary" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "strong",
                                      { staticClass: "ml-3 primary-text" },
                                      [_vm._v("Loading...")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "cell(isChecked)",
                            fn: function (data) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-100 d-flex align-items-center",
                                  },
                                  [
                                    _c(_setup.CCheckbox, {
                                      attrs: { label: "" },
                                      on: {
                                        input: function ($event) {
                                          return _setup.storeCheck(
                                            $event,
                                            data.item
                                          )
                                        },
                                      },
                                      model: {
                                        value: data.item.isChecked,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "isChecked", $$v)
                                        },
                                        expression: "data.item.isChecked",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(image)",
                            fn: function (data) {
                              return [
                                data.item.thumbnail
                                  ? _c(_setup.CPreview, {
                                      staticClass: "img",
                                      attrs: {
                                        src: data.item.thumbnail,
                                        thumbnail: "",
                                        "hide-wrapper": "",
                                      },
                                    })
                                  : _c("font-awesome-icon", {
                                      attrs: {
                                        icon: ["fas", "image"],
                                        size: "10x",
                                      },
                                    }),
                              ]
                            },
                          },
                          {
                            key: "cell(name)",
                            fn: function (data) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-items-baseline",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(data.item.name)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "text-with-overflow link",
                                        staticStyle: {
                                          color:
                                            "var(--Primary-primary, #7258e0)",
                                        },
                                      },
                                      [_vm._v(_vm._s(data.item.id))]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-end" },
                                  [
                                    !_setup.entitiesAdded.some(
                                      (t) => t.id == data.item.id
                                    )
                                      ? _c(
                                          "b-btn",
                                          {
                                            attrs: {
                                              variant: "outline-primary",
                                              disabled: _setup.loading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _setup.addEntityAccess(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Select\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _setup.entitiesAdded.some(
                                      (t) => t.id == data.item.id
                                    )
                                      ? _c(
                                          "b-btn",
                                          {
                                            attrs: {
                                              variant: "outline-primary",
                                              disabled: _setup.loading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _setup.removeEntityAccess(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                Remove\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3266082548
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _setup.totalCount / _setup.itemsPerPage > 1
                  ? _c("b-pagination", {
                      attrs: {
                        size: "md",
                        disabled: _setup.loading,
                        "total-rows": _setup.totalCount,
                        "per-page": _setup.itemsPerPage,
                      },
                      model: {
                        value: _setup.currentPage,
                        callback: function ($$v) {
                          _setup.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _setup.accessRestriction === _setup.AccessRestriction.FULL_ACCESS
          ? _c("div", { staticClass: "overlay" }, [
              _c("strong", { staticClass: "mr-2" }, [_vm._v("Full Access:")]),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    "This user can edit any " +
                      _setup.entityTypeNames[_setup.props.entityType].singular +
                      " and has no restrictions."
                  ),
                },
              }),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }